import React from 'react';
import AppProvider, { useApp } from './app';
import AlertProvider, { useAlert } from './alert';
import AuthProvider, { useAuth } from './auth';
import NotificationsProvider, { useNotifications } from './notifications';
import SolicitationProvider, { useSolicitation } from './solicitation';
import { useImages, ImageProvider } from './images';
import { Props } from 'props';
import { ConfigProvider } from 'antd';
import locale from 'antd/locale/pt_BR';

export {
  useAuth,
  useApp,
  useAlert,
  useSolicitation,
  useNotifications,
  useImages,
};

const GlobalContext: React.FC<Props> = ({ children }) => {
  return (
    <AppProvider>
      <ConfigProvider
        locale={locale}
        theme={{
          token: {
            colorPrimary: '#293778',
          },
        }}
      >
        <AlertProvider>
          <AuthProvider>
            <NotificationsProvider>
              <SolicitationProvider>
                <ImageProvider>{children}</ImageProvider>
              </SolicitationProvider>
            </NotificationsProvider>
          </AuthProvider>
        </AlertProvider>
      </ConfigProvider>
    </AppProvider>
  );
};

export default GlobalContext;
